module.exports = __webpack_public_path__ + "img/bg_bottom_left_corner.007ee945.png";